import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    legends: Array,
    focused: Boolean
  }

  connect() {
    this.setupTypeahead()

    if (this.focusedValue) this.focusInput()
  }

  // Private

  setupTypeahead() {
    $(this.inputTarget).typeahead(
      {
        hint: true,
        highlight: true,
        minLength: 0
      },
      {
        limit: 5,
        source: this.suggestionMatcher()
      }
    )

    // typeahead builds its hint by cloning the input, target attribute
    // included; drop it from the clone so inputTarget stays the real input.
    this.element.querySelector(".tt-hint")?.removeAttribute(`data-${this.identifier}-target`)
  }

  suggestionMatcher() {
    return (query, callback) => {
      const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      const regex = new RegExp(escapedQuery, "i")

      callback(this.legendsValue.filter(legend => regex.test(legend)))
    }
  }

  // Bootstrap focuses the modal once its fade transition ends, stealing any
  // focus given earlier, so focus again after that event.
  focusInput() {
    const modal = this.element.closest(".modal")
    if (modal) $(modal).one("shown.bs.modal", () => this.focus())

    this.focus()
  }

  focus() {
    this.inputTarget.focus({ preventScroll: true })
  }
}
